import { Controller } from 'react-hook-form'
import classNames from 'classnames'
import { Input } from 'rsuite'

export default function EditTextCell({
  id,
  rowData,
  rowSchema,
  dataKey,
  register,
  control,
  errors,
  onChangeCell = () => {},
  isRequired = true,
  isEdit,
  styleSheet,
  ...props
}) {
  const editing = rowData.status === 'EDIT' || isEdit
  const _id = id || rowData.id
  return (
    <span {...props} className={editing ? 'table-content-editing' : ''}>
      {editing ? (
        <>
          {rowSchema.name === 'projectCode' ? (
            <Controller
              name={_id}
              control={control}
              defaultValue={rowData[dataKey] || ''}
              render={(props) => {
                return (
                  <Input
                    style={{ marginTop: 8 }}
                    placeholder={`ระบุ${rowSchema.label}`}
                    value={props.value}
                    onChange={(value) => {
                      // if (isNaN(value)) {
                      //   return
                      // }
                      props.onChange(value)
                      onChangeCell(value)
                    }}
                  />
                )
              }}
            />
          ) : (
            <Controller
              name={_id}
              control={control}
              defaultValue={rowData[dataKey] || ''}
              rules={
                isRequired && {
                  required:
                    rowSchema.name === 'organizationName'
                      ? 'ชื่อหน่วยงานให้ทุน อื่น ๆ'
                      : rowSchema.label,
                }
              }
              render={(props) => {
                return (
                  <Input
                    style={{ marginTop: 8, ...styleSheet }}
                    className={classNames('rs-input', errors[_id] && 'is-error')}
                    placeholder={`ระบุ${rowSchema.label}`}
                    value={props.value}
                    onChange={(value) => {
                      // if (isNaN(value)) {
                      //   return
                      // }
                      props.onChange(value)
                      onChangeCell(value)
                    }}
                  />
                )
              }}
            />
          )}
        </>
      ) : (
        <span>{rowData[dataKey]}</span>
      )}
    </span>
  )
}
